interface PhaseIndicatorProps {
  phases: any;
  phaseOrder: any;
  currentPhase: any;
}

export default function PhaseIndicator({ phases, phaseOrder, currentPhase }: PhaseIndicatorProps) {
  // Filter out pending and completed from display
  const displayPhases = phaseOrder.filter((phase: string) => phase !== 'pending' && phase !== 'completed');
  
  return (
    <div className="flex-shrink-0 border-b border-gray-200 bg-white">
      <div className="flex items-center justify-center px-2 py-0.5">
        {/* Phase Tabs - Gecentreerd */}
        <div className="flex items-center gap-0">
          {displayPhases.map((phaseKey: string, index: number) => {
            const phase = phases[phaseKey];
            const isActive = currentPhase === phaseKey;
            const isPast = phaseOrder.indexOf(currentPhase) > phaseOrder.indexOf(phaseKey);
            
            return (
              <div
                key={phaseKey}
                data-testid={isActive ? 'phase-label' : undefined}
                data-phase={phaseKey}
                data-phase-active={isActive ? 'true' : undefined}
                className={`flex items-center gap-1 px-1.5 py-0.5 text-[11px] font-medium transition-colors leading-tight ${
                  isActive
                    ? 'text-orange-600 border-b-2 border-orange-600'
                    : isPast
                    ? 'text-gray-400'
                    : 'text-gray-600'
                }`}
                title={phase?.name || phaseKey}
              >
                <span className="text-[11px]">{phase?.icon || '○'}</span>
                <span className="hidden md:inline text-[11px]">{phase?.name || phaseKey}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}




